import type { SVGProps } from "react";
export interface BrainIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BrainIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BrainIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.761 23.124c1.357 0 2.91-.802 3.57-2.319.87-.15 1.653-.54 2.26-1.163.695-.712 1.094-1.658 1.185-2.72.873-.972 1.354-2.127 1.35-3.312-.005-1.086-.42-2.11-1.175-2.943.401-1.79-.41-3.43-1.706-4.346-.219-1.387-1.118-2.345-2.233-2.88-.397-1.344-1.731-2.566-3.5-2.566-1.982 0-3.444 1.535-3.62 3.069l-.017.306.001 15.168c0 1.307.584 2.278 1.398 2.89.772.582 1.71.816 2.487.816M13.144 4.118c.038-.155.14-.368.343-.57.251-.25.602-.423 1.025-.423s.768.173 1.017.422c.267.267.357.555.357.703 0 .49.32.926.788 1.073.904.286 1.376.848 1.376 1.662 0 .427.243.818.627 1.007.892.441 1.415 1.475.956 2.574-.192.46-.058.992.328 1.307.64.52.912 1.145.914 1.747.003.612-.274 1.334-.983 2.016a1.13 1.13 0 0 0-.345.812c0 .763-.242 1.29-.566 1.623-.322.33-.815.556-1.495.556-.546 0-1.012.392-1.108.929-.144.81-.911 1.318-1.617 1.318-.372 0-.813-.122-1.134-.363-.279-.21-.5-.53-.5-1.094L13.124 4.25z"
      />
      <path
        fill={color}
        d="M10.857 4.117a1.25 1.25 0 0 0-.343-.569 1.44 1.44 0 0 0-1.026-.423c-.421 0-.768.172-1.016.42-.268.268-.36.558-.36.705 0 .491-.317.925-.786 1.072-.904.285-1.377.848-1.377 1.662 0 .428-.243.82-.627 1.009-.891.44-1.415 1.475-.956 2.573.192.46.058.992-.328 1.307-.64.52-.91 1.145-.913 1.748-.002.612.274 1.334.983 2.015.22.212.346.506.346.812 0 .763.241 1.291.565 1.623.283.289.695.498 1.25.546l.246.01.199.018c.456.082.824.44.908.91.144.81.91 1.32 1.616 1.32a1.97 1.97 0 0 0 1.135-.364c.244-.183.445-.451.49-.893l.011-.2V4.25zm2.267 15.3-.006.242c-.067 1.186-.628 2.075-1.391 2.65-.773.581-1.712.816-2.49.816-1.356 0-2.911-.803-3.57-2.32-.87-.152-1.65-.54-2.258-1.162-.695-.713-1.096-1.66-1.186-2.722-.872-.972-1.353-2.126-1.348-3.31.005-1.087.418-2.112 1.173-2.945-.4-1.788.41-3.428 1.704-4.345.219-1.386 1.119-2.346 2.234-2.881C6.382 2.096 7.719.875 9.488.875c2.114 0 3.637 1.746 3.637 3.375z"
      />
    </svg>
  );
}
